import React from "react";
import Modal from "react-modal";

import Button from "../../formElements/button/Button";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 400,
  },
};

Modal.setAppElement("#modal");

const Modals = ({ modalIsOpen, closeModal, error, children }) => {
  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        {children || (
          <>
            <h5>{error}</h5>
            <Button onClick={closeModal} label="Okay" className="mt-5" />
          </>
        )}
      </Modal>
    </div>
  );
};

export default Modals;
